import styled from 'styled-components';

export const CardHeader = styled.div`
  .s-divider {
    display: flex;
    align-items: center;

    > cc-icon {
      margin-right: 6px;
    }

    > p {
      font-size: 14px;
      line-height: 20px;

      > b {
        font-weight: 900;
      }

      > span {
        color: #4f6168;
      }
    }
  }
`;

export const CardHeaderDropdown = styled.div`
  .s-header {
    height: 40px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > button {
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      background-color: #ffffff;

      > cc-icon {
        height: 20px;
        width: 20px;
        color: #5b36f2;
      }

      &:hover {
        background-color: #e2dffd;
      }

      &:focus,
      &:active {
        background-color: #c6c0fc;
      }
    }
  }

  .s-children {
    margin-top: 24px;
  }

  .s-divider {
    display: flex;
    align-items: center;

    > img {
      margin-right: 6px;
    }

    > p {
      font-size: 14px;
      line-height: 20px;

      > b {
        font-weight: 900;
      }

      > span {
        color: #4f6168;
      }
    }
  }
`;
